import { useTranslation } from 'react-i18next'
import { mainLightGrey } from '~app/helper/Colors'

const DocumentTable = ({ children }: React.PropsWithChildren<unknown>) => {
  const { t } = useTranslation()
  return (
    <div style={styles.containerStyle}>
      <div style={styles.tableHeaderStyle}>
        <div />
        <p style={{ ...styles.headerTextStyle, flex: 0.1, marginLeft: 20 }}>
          {t('documentView.publicId')}
        </p>
        <p style={{ ...styles.headerTextStyle, flex: 0.4 }}>
          {t('documentView.receiver')}
        </p>
        <p style={{ ...styles.headerTextStyle, flex: 0.4 }}>
          {t('documentView.userId')}
        </p>
        <div style={{ width: 48 }} />
      </div>
      <div style={styles.tableBodyStyle}>{children}</div>
    </div>
  )
}

const styles: InlineStyles = {
  containerStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 20,
  },
  tableHeaderStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '54%',
    alignSelf: 'flex-start',
  },
  headerTextStyle: {
    fontSize: 12,
    color: mainLightGrey,
  },
  tableBodyStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
}

export default DocumentTable
